<article class="container legal-policy-page">
  <div class="row mx-2">
    <div class="col-12 about-us-copy">
      <h1 class="legal-policy-page__title">About Us</h1>

      <p class="text-justify theme-color mb-3">
        CitizeX is a civic engagement platform built to bring clarity, trust,
        and real human connection back to public discourse. It connects voters,
        elected officials, candidates, and organizations with the goal of
        fostering authentic dialogue through modern technology.
      </p>

      <p class="text-justify theme-color mb-3">
        At a time when political discourse is often shaped by anonymity,
        misinformation, and algorithm-driven noise, CitizeX creates a more
        credible alternative. Every participant contributing to CitizeX is
        verified, ensuring that conversations happen between real people. No
        bots, fake accounts, or impersonators are allowed to comment.
      </p>

      <p class="text-justify theme-color mb-3">
        The platform enables users to discover and engage directly with leaders
        at the national, state, and local levels through virtual town halls,
        community discussions, and polling. Rather than passively consuming
        content, users can ask questions, share perspectives, and participate in
        ongoing civic dialogue in a space built for accountability and
        transparency.
      </p>

      <p class="text-justify theme-color mb-3">
        Powered by key partners, CitizeX combines advanced technology with
        trusted verification to create a more reliable civic experience.
        Coresee, a video conferencing platform, enables elected officials,
        candidates, and organizations to host live public conversations with
        tools designed to better present ideas, structure dialogue, and gather
        meaningful feedback from participants. CitizeX also uses an API provided
        by
        <a
          href="https://www.cicerodata.com/company/"
          target="_blank"
          rel="noopener noreferrer"
          >Cicero</a
        >
        to generate current elected official offices and bios.
      </p>

      <p class="text-justify theme-color mb-4">
        CitizeX was built on a simple idea: public dialogue works better when
        people know they are hearing from real people. By combining verified
        identity with tools for direct engagement, CitizeX offers a new model
        for digital democracy, and one that is more trustworthy, more informed,
        and more human.
      </p>
    </div>
  </div>
</article>
